export const updateVariationEan = () => {
  const updateEan = (variation) => {
      const eanElement = document.querySelector('#product-ean');
      if (!eanElement) return;

      if (variation && variation.global_unique_id) {
          eanElement.textContent = variation.global_unique_id;
      } else {
          eanElement.textContent = wp.i18n.__('EAN code missing', 'smartwood');
      }
  };

  jQuery(document).ready(function($) {
    $('form.variations_form').on('found_variation', function (event, variation) {
      updateEan(variation);
    });
  });
};
